export enum ResolverType {
    HOME = 'home',
    TRANSACTION_CALCULATOR_A = 'transactionCalculatorA',
    TRANSACTION_CALCULATOR_B = 'transactionCalculatorB',
    TRANSACTION_INSTRUCTIONS = 'transactionInstructions',
    TRANSACTION_SCREENSHOT = 'transactionScreenshot',
    TRANSACTION_STATES = 'transactionStates',
    USER_VALIDATION = 'userValidation',
    DASHBOARD_TRANSACTIONS = 'dashboardTransactions',
    DASHBOARD_TRANSACTION_INSTRUCTIONS = 'dashboardTransactionInstructions',
    DASHBOARD_TRANSACTION_STATES = 'dashboardTransactionStates',
    DASHBOARD_TRANSACTION_SCREENSHOT = 'dashboardTransactionScreenshot',
    DASHBOARD_VALIDATIONS = 'dashboardValidations',
    DASHBOARD_HELP_CENTER = 'dashboardHelpCenter',
    WEBVIEW = 'webview',
    NEW_TRANSACTION = 'new-transaction',
    RESET_PASSWORD = 'resetPassword',
    DASHBOARD_DEALS = 'dashboardDeals',
    HELP = 'help'
}
